<div class="user-details-dialog-container">
  <div class="leftFloat">
    <h3>Select a Respondent List</h3>
  </div>
  <div class="rightFloat">
    <button mat-icon-button matDialogClose="no" matTooltip="Close" matTooltipPosition="below">
      <mat-icon class="user-details-dialog-close-icon">close</mat-icon>
    </button>
  </div>
</div>
<div>
  <app-panels #panelSelector [canEdit]="false" (selected)="panelSelected($event)"></app-panels>
</div>
